/* eslint-disable */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useRef } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { getBlockedSites, postBlockedSites } from '../../Components/action/common'
import { jsx } from "@emotion/core";
import { useSelector } from 'react-redux'
import InfoIcon from './InfoIcon'
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import NoSitesBg from './NoSitesBg'
import SurePopupIcon from './SurePopupIcon'
import { Cancel } from '../../Components/LandingHeader/Feedback/icons/Icons'
import NoSitesBgDark from './NoSitesBgDark'
import { usePosthog } from '../../PosthogProvider'

function getHoursAndMinutesFromSeconds(totalSeconds) {
  let hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  let minutes = Math.floor(remainingSeconds / 60);

  if (!hours || isNaN(hours)) {
    hours = 0;
  }

  if (!minutes || isNaN(minutes)) {
    minutes = 0;
  }

  return {
    hours: hours,
    minutes: minutes
  };
}


const DeletingSiteAnimation = ({ site, onFinish, handleUndo, theme }) => {
  useEffect(() => {
    const interval = setTimeout(() => {
      onFinish(site);
    }, 3000);
    return () => {
      clearInterval(interval);
    }
  }, [])
  return (
    <div className="field-block mt-5" id={`sites_${site.id}`}>
      <div className="field-collection"
        style={{ padding: '25px 20px' }}
        css={{
          background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white)` 
        }}
      >
        <div className="logo-text flex items-center w-1/2">
          <span className='accent-text-color' style={{ textTransform: 'capitalize', fontSize: '14px', fontWeight: '500' }}>[Removed]</span>
        </div>
        <div className="">
          <span onClick={() => handleUndo(site)}
            className='accent-text-color' style={{ textTransform: 'capitalize', fontSize: '12px', fontFamily: "Karla", fontWeight: '500', cursor: 'pointer' }}>Undo</span>
        </div>
      </div>
      <div
        style={{
          height: '5px',
          background: `var(--accent-color)`,
          width: '100%',
          animation: 'progress-animation 3s linear',
        }}
      ></div>
    </div>
  )
}
const Interval = ({ theme, handleFromTimeChange, handleTimeChange, handleAddInterval, handleRemoveInterval, blockedSites }) => {
  const customInputStyle = {
    backgroundColor: 'lightgray',
    borderRadius: '4px',
    padding: '5px',
  };

  return (
    <div className={theme}>
      {blockedSites.intervals.length ?
        blockedSites.intervals.map((interval, index) => (
          <div className="field-data flex !mb-[10px] items-center" key={index}>
            <div className="filed-data-block">
              <TimePicker
                onChange={newFromTime => handleFromTimeChange(newFromTime, index)}
                value={interval.fromTime}
                disableClock={true}
                isOpen={false}
                format="h:mm a"
                className={theme == 'dark' ? 'custom-input-select-dark' : ""}
              />
            </div>
            <span style={{ width: '8%', textAlign: 'center' }}> to </span>
            <div className="filed-data-block">
              <TimePicker
                onChange={newToTime => handleTimeChange(newToTime, index)}
                value={interval.toTime}
                disableClock={true}
                isOpen={false}
                format="h:mm a"
                className={theme == 'dark' ? 'custom-input-select-dark' : ""}
              />
            </div>
            <div className='absolute right-[-12%] cursor-pointer w-[30px] h-[30px] rounded-[57px] flex items-center justify-center border border-black/10 dark:border-white/15' onClick={() => handleRemoveInterval(index)}>
              <Cancel color="grey" />
            </div>
          </div>

        )) : ""}

      <div className="field-button" style={{ marginTop: 10 }}>
        <button className="changeName"
          css={{
            background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
            color: `var(--accent-color) !important`

          }}
          onClick={handleAddInterval}>
          Add Interval
        </button>
      </div>
    </div>
  );
};

const customStyles = {
  // Style for the input
  input: (provided) => ({
    ...provided,
    backgroundColor: 'lightgray',
    borderRadius: '4px',
    padding: '5px',
  }),

};

function SiteBlocker({ activeTab, setActiveTab }) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const { colorPicker, colorPickerDark, theme } = useSelector(state => state.theme)
  const [onMouseEnterProfile, setOnMouseEnterProfile] = useState(false)
  const [isDeleted, setIsDeleted] = useState(false);
  const [id, setId] = useState(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showSaving, setShowSaving] = useState(false);
  const [showSaved, setShowSaved] = useState(false);
  const [showBlockInfo, setShowBlockInfo] = useState(false);
  const divRef = useRef(null);
  const [surePopupShow, setSurePopupShow] = useState(false);
  const [deletingSiteIds, setDeletingSiteIds] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const { captureEvent } = usePosthog();

  const handleAddInterval = () => {
    setBlockedSites(((prev) => ({
      ...prev, ['intervals']: [...prev.intervals, { fromTime: '', toTime: '' }]
    })));
  };

  const handleFromTimeChange = (newFromTime, index) => {
    setBlockedSites(prevState => {
      const updatedIntervals = [...prevState.intervals];
      updatedIntervals[index].fromTime = newFromTime;
      return { ...prevState, intervals: updatedIntervals };
    });
  };

  const handleTimeChange = (newToTime, index) => {
    setBlockedSites(prevState => {
      const updatedIntervals = [...prevState.intervals];
      updatedIntervals[index].toTime = newToTime;
      return { ...prevState, intervals: updatedIntervals };
    });
  };

  const handleRemoveInterval = index => {
    setBlockedSites(prevState => {
      const updatedIntervals = [...prevState.intervals];
      updatedIntervals.splice(index, 1);
      return { ...prevState, intervals: updatedIntervals };
    });
  };

  const [blockedSites, setBlockedSites] = useState({
    blockedSites: [],
    // intervals:[{"fromTime":"2:50","toTime":"20:30"}],
    intervals: [],
    dailyUsage: 0,
    usageDays: [],
    status: false,
    visitCount: 1
  });

  const handleUsageDaysChange = day => {
    console.log("selectedOptions", day);

    const updatedSchedule = [...blockedSites.usageDays];
    const index = updatedSchedule.indexOf(day);

    if (index === -1) {
      updatedSchedule.push(day);
    } else {
      updatedSchedule.splice(index, 1);
    }

    setBlockedSites(prevState => ({
      ...prevState,
      usageDays: updatedSchedule
    }));
  };

  const weekDayOptions = [
    { value: 'Monday', label: 'Mon' },
    { value: 'Tuesday', label: 'Tue' },
    { value: 'Wednesday', label: 'Wed' },
    { value: 'Thursday', label: 'Thu' },
    { value: 'Friday', label: 'Fri' },
    { value: 'Saturday', label: 'Sat' },
    { value: 'Sunday', label: 'Sun' }
  ]

  const handleTypeChange = (site, status) => {
    const id = site.id;
    const updatedData = blockedSites.blockedSites.map((blocked_site) => {
      if (blocked_site.id == id) {
        return {
          ...blocked_site,
          isSoft: status
        }
      }
      return blocked_site;
    });

    setBlockedSites(((prev) => ({
      ...prev, ['blockedSites']: updatedData
    })));
  }
  const handleDelete = async (site) => {
    setDeletingSiteIds((prevDeletingSiteIds) => [...prevDeletingSiteIds, site.id]);
  }


  const handleToggle = async (site, value) => {
    const id = site.id;
    const updatedData = blockedSites.blockedSites.map((blocked_site) => {
      if (blocked_site.id == id) {
        return {
          ...blocked_site,
          isActive: value
        }
      }
      return blocked_site;
    });

    setBlockedSites(((prev) => ({
      ...prev, ['blockedSites']: updatedData
    })));
  }

  const updateDetails = async (formData) => {
    setSubmitted(true);
    try {
      if (!JSON.stringify(blockedSites.blockedSites).includes(formData.site)) {
        const maxId = blockedSites.blockedSites.length > 0 ? Math.max(...blockedSites.blockedSites.map(site => site.id)) : 0;

        const data = {
          blockedSites: [
            ...blockedSites.blockedSites,
            {
              id: maxId + 1,
              url: !formData.site.startsWith('https://') ? 'https://' + formData.site : formData.site,
              isSoft: true,
              isActive: true,
            },
          ],
          intervals: [...blockedSites.intervals],
          dailyUsage: blockedSites.dailyUsage,
          usageDays: [...blockedSites.usageDays],
          status: blockedSites.status,
          visitCount: blockedSites.visitCount
        };
        setBlockedSites(prevState => ({
          ...prevState,
          ...data
        }));
      }

      reset();

    } catch (error) {
      console.log(error);
    }

  }

  useEffect(() => {
    getBlockedSitesData();
    // return () => {
    //   const updatedSites = blockedSites.blockedSites.filter(site => !deletingSiteIds.includes(site.id));
    //   if (deletingSiteIds) {
    //     setBlockedSites(((prev) => ({
    //       ...prev, ['blockedSites']: updatedSites
    //     })));
    //   }
    // }
  }, [])


  const getBlockedSitesData = async () => {
    let response = await getBlockedSites();
    if (response && Object.keys(response).length > 0) {
      // if (response.visitCount <= 4) {
      //   setShowInfo(true);
      // } else {
      //   setShowInfo(false);
      // }
      setBlockedSites(response);
      setId(response.id);
    }
  }
  useEffect(() => {
    // if (blockedSites.visitCount <= 4) {
    //   setShowInfo(true);
    // } else {
    //   setShowInfo(false);
    // }
    if (!isDeleted) {
      if (Object.keys(blockedSites.blockedSites).length || blockedSites.status) { //should be false
        setShowSaving(true);
        setShowSaved(false);
        postBlockedSites(blockedSites, id, isDeleted).then((response) => {
          // Update 
          // try{
          //   if(window?.chrome){
          //     window?.chrome.runtime.sendMessage('dgockbmbhnmimfgealhocmjmchgiieig', { action: 'updateBlockedSites', data: response }, (response) => {
          //       //console.log('Blocked sites are updated');
          //     });
          //   }
          // }catch(e){
          //   //console.log('ERROR: Blocked sites are not updated', e);
          // }
          setId(response.id);
          setTimeout(() => {
            setShowSaving(false);

            setShowSaved(true);
            setTimeout(() => {
              setShowSaved(false);
            }, 3000);
          }, 2000);
        })
      }
    }

  }, [blockedSites])


  const handleMenuClose = () => {
    setMenuIsOpen(false);
  };
  const handleFocus = () => {
    setMenuIsOpen((prevMenuIsOpen) => !prevMenuIsOpen); // Toggle menuIsOpen state
  };

  const getsiteTitle = (value) => {
    const url = new URL(value);
    const parts = url.hostname.split('.');
    const hostname = parts.length > 2 ? parts.slice(-2).join('.') : url.hostname;
    return hostname.split('.')[0];
  }
  const init = async () => {

    // Get the access token from the callback url
    const accessToken = localStorage.getItem('token');
    /* eslint-disable no-undef */
    if (accessToken && chrome.storage !== undefined) {
      // If there is an access token present
      chrome.storage.local.set({ accessToken: accessToken }, function () {
      });
    }
  };

  init();


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setShowBlockInfo(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    handleSubmit(updateDetails)(event);
  };

  function updateDailyUsage(newSeconds, isMinutes) {

    if (surePopupShow) {
      setSurePopupShow(false)
    }
    let newTime = 0;
    let existing = getHoursAndMinutesFromSeconds(blockedSites.dailyUsage);

    let newTimeInSeconds = newSeconds * (isMinutes ? 60 : 3600);
    if (!newTimeInSeconds || isNaN(newSeconds)) {
      newTimeInSeconds = 0
    }

    if (isMinutes) {
      newTime = (existing.hours * 3600) + newTimeInSeconds
    } else {
      newTime = (existing.minutes * 60) + newTimeInSeconds
    }

    setBlockedSites(prevState => ({
      ...prevState,
      dailyUsage: newTime,
    }))

    // if (newTime > 1800 && !hasConfirmedMax) {
    //   return setSurePopupShow(true);
    // }
    if (newTime > 1800) {
      return setSurePopupShow(true);
    }
  }

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',];

  const renderDay = (day) => {
    const isSelected = blockedSites.usageDays.includes(day);

    return (
      <div
        key={day}
        tooltip={day}
        className={`day dark:border dark:border-white/15 flex items-center justify-center h-[40px] w-[40px] rounded-[50%] text-center text-[18px] cursor-pointer text-white m-auto ${isSelected ? 'selected' : ''}`}
        css={{
          background: isSelected ? 'var(--accent-color)' : ''
        }}
        onClick={() => handleUsageDaysChange(day)}
      >
        {day.charAt(0)}
      </div>
    );
  };

  return (
    <>
      <li 
        css={{
          '&:hover .accordion-title': {
            color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
          },
          '.accordion-title': {
            color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "profile")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "profile")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "profile")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "profile")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "profile")) ? "black !important" : "white !important") : "white"
          },
        }}
        className={`li-setting-tab ${(activeTab == 'block') ? 'active' : ''} site-blocker-settings ${theme}`}>
        <div className="settings-accordion-tab"
          onClick={() => {
            if (blockedSites.status) {
              if (blockedSites.visitCount <= 4 && activeTab !== 'block') {
                setBlockedSites(prevState => ({
                  ...prevState,
                  visitCount: ++blockedSites.visitCount
                })
                )
              }
              setActiveTab(activeTab => activeTab == 'block' ? null : 'block');
            }
          }
          }

          style={{ background: theme == "dark" ? "black" : "" }}
          css={{
            background: activeTab == 'block' ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important`) : '',
            '&:hover': {
              background: theme == 'dark' ? `linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important`,
            }
          }}>
          <div className="settings-accordion-heading" >
            <figure className="settings-icon">
              <img src="images/ban.svg" className="img-default dark:invert-color" />
            </figure>
            <h3 className="accordion-title uppercase dark:text-white">Site Blocker</h3>
          </div>
          <div className="settings-accordion-text-arrow">

            {activeTab && showSaving &&
              <div className="settings-accordion-changes">
                <img src="images/save.svg" className="img-default" />
                <span>Saving Changes</span>
              </div>
            }
            {activeTab && showSaved &&
              <div className="settings-accordion-changes">
                <img src="images/save.svg" className="img-default" />
                <span>Changes Saved</span>
              </div>
            }

            {blockedSites.status &&
              <div className="settings-accordion-arrow-site">
                <img src="images/arrow-down.svg" className="dark:invert-color" />
              </div>
            }

            <div className="accordion-toggle"
            >
              <div className="on-off-toggle" >
                <input className="on-off-toggle__input custom_on_off_input" type="checkbox" id="status"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(event) => {
                    setActiveTab(activeTab => activeTab == 'block' ? null : 'block');

                    setBlockedSites(prevState => ({
                      ...prevState,
                      status: event.target.checked
                    })
                    )

                    // Capture site blocker enabled or disabled event
                    captureEvent(event.target.checked ? 'Site Blocker Enabled' : 'Site Blocker Disabled');

                  }}
                  checked={blockedSites.status}

                />

                <label htmlFor="status" className="on-off-toggle__slider focus-label"
                  css={{
                    background: !blockedSites.status ? `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white-reverse),0.8),rgba(var(--theme-mode-rgb-white-reverse),0.8)),linear-gradient(0deg,var(--accent-color),var(--accent-color)),linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.05),rgba(var(--theme-mode-rgb-white),0.05)),var(--theme-mode-color-white) !important` : `var(--accent-color) !important`
                  }}
                ></label>
              </div>
            </div>

          </div>

        </div>

        {
          activeTab == 'block' && blockedSites.status && <div className="settings-accordion-content">
            <div className="inner-form pt-5 relative">
              <form onSubmit={handleFormSubmit} className="content-block">
                <div className="field-block mt-[30px]">
                  <div className="flex justify-between items-center">
                    <label className="field-label dark:text-white">Blocked Sites</label>
                  </div>
                  <div className="block-field-info font text-secondary text-base mb-0" style={{ opacity: 1 }}><span className='accent-text-color'>Hard Block : </span> Stops you from completely from accessing a site (unless you have a daily allowance set)</div>
                  
                  <div className="block-field-info font text-secondary text-base mb-0" style={{ opacity: 1 }}><span className='accent-text-color'>Soft Block : </span> Makes you wait 10 seconds before accessing a site on your block list.</div>
                  <div className="settings-accordion-arrow mt-[30px]">
                    {/* {
                      theme != "dark" ? <InfoIcon isActiveSettings={activeTab} onMouseEnterProfile={onMouseEnterProfile} isProfileActive={activeTab == 'block'} profileActive="profile" /> : <img src="images/info-outline.svg" />
                    } */}
                    {/* <InfoIcon isActiveSettings={activeTab} onMouseEnter={onMouseEnterInfo} isProfileActive={activeTab == 'block'} profileActive="profile" />  */}
                  </div>
                  {showInfo &&
                    <div className='info-sites'
                      css={{
                        background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white)`
                      }}
                    >
                      <div className="w-[341px]">
                        <span
                          className="text-[16px] font-playfair-display font-bold"
                          css={{
                            color: `var(--accent-color) !important`
                          }}
                        >Soft Block</span>
                        <h4
                          css={{
                            color: `var(--accent-color) !important`
                          }}
                        >A New Way To Block Sites</h4>
                        <p
                          css={{
                            color: `var(--accent-color) !important`
                          }}
                        >The soft block shows you a countdown of 10 seconds , giving you time to stop and reflect on whether or not visiting that site is the best use of your time.</p>
                      </div>
                      <div>
                        <img src="images/breathInthumb.svg" className="absolute z-9 top-[5%] dark:invert-color"></img>
                        <img src="images/hardThumb.svg" className="absolute top-0 right-[4%] dark:invert-color"></img>

                      </div>
                      <span className='info-sites-close' onClick={() => setShowInfo(false)}><img src="images/close-model.svg" className="dark:invert-color"></img></span>
                    </div>
                  }

                  <div className="field-data">
                    <div className="filed-data-block">
                      <div className="info_input rounded-[10px] border border-black/10 dark:border-white/15">
                        <input placeholder="Enter a web address (ex:facebook.com)" id="site" name='site' {...register("site", {
                          required: {
                            value: true,
                            message: 'Site is required'
                          },
                          pattern: {
                            value:
                              /^([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/,
                            message: "That is not a valid URL. Please write the site name followed by the domain extension. (Eg. sitename.com)",
                          },
                        })
                        } className="input-field dark:text-white"/>
                        <div className="info_text">
                          <span>https://</span>
                        </div>
                        {errors.site && <span className="input-internal-label absolute right-5 top-[18px]"><InfoIcon color={'var(--overDue-color)'}></InfoIcon></span>}
                      </div>
                      {submitted && errors.site && <p className="error">{errors.site.message}</p>}
                    </div>
                    <div className="field-button">
                      <button type="submit"
                        className="changeName"
                        css={{
                          background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                          color: `var(--accent-color) !important`

                        }}
                        style={{ cursor: "pointer" }}>Block Site</button>
                    </div>
                  </div>
                </div>
              </form>
              {blockedSites.blockedSites.length ?
                <>
                  <div className="sitesList" style={{ marginTop: '30px' }}>
                    {blockedSites.blockedSites.map((site, index) => (

                      <div>
                        <div key={site.id}>
                          {deletingSiteIds.includes(site.id) ? (
                            <DeletingSiteAnimation site={site} onFinish={() => {
                              setDeletingSiteIds(p => p.filter(i => i != site.id))
                              setBlockedSites((prevSites) => ({
                                ...prevSites,
                                blockedSites: prevSites.blockedSites.filter(j => j.id != site.id)
                              }));
                            }} handleUndo={(site) => {
                              setDeletingSiteIds(p => p.filter(i => i != site.id))

                            }}
                              theme={theme} />
                          ) : (
                            <div className="field-block mt-5" id={`sites_${site.id}`}>
                              <div className="field-collection"
                                css={{
                                  background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.03) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.03) 100%), var(--theme-mode-color-white);`,

                                  '&:hover': {
                                    background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white)`
                                  }
                                }}
                              >
                                <div className="logo-text flex items-center w-1/2">
                                  <img src={`https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${site.url}&size=48`} className="w-full max-w-[48px] rounded-[50%] p-[10px]" />

                                  <div className="text-black dark:text-white">
                                    <span className="text-sm text-capitalize text-black dark:text-white">{getsiteTitle(site.url)}</span>
                                    <p className="text-sm text-black dark:text-white">{site.url}</p></div>
                                </div>

                                <div className='cta-btn flex items-center w-[44%]'>
                                  <button
                                    className={`block-btn py-[6px] px-[15px] w-[120px] h-[35px] bg-[var(--theme-mode-color-white)] rounded-[10px] text-[12px] border-none m-[5px]`}
                                    onClick={() => { handleTypeChange(site, false); }}
                                    css={{
                                      background: site.isSoft ? `var(--theme-mode-color-white) !important` : `var(--accent-color)`,
                                      color: site.isSoft ? 'var(--theme-mode-color-white-reverse)' : 'var(--theme-mode-color-white-reverse) !important',
                                    }}
                                  ><span
                                    css={{
                                      color: site.isSoft ? 'var(--theme-mode-color-white-reverse)' : 'var(--theme-mode-color-white)',
                                      opacity: site.isSoft ? '0.5' : '1'
                                    }}
                                  >Hard Block</span></button>
                                  <button
                                    className={` block-btn py-[6px] px-[15px] w-[120px] h-[35px] bg-[var(--theme-mode-color-white)] rounded-[10px] text-[12px] border-none m-[5px]`}
                                    onClick={() => { handleTypeChange(site, true); }}
                                    css={{
                                      background: !site.isSoft ? `var(--theme-mode-color-white) !important` : `var(--accent-color)` ,
                                      color: !site.isSoft ? `var(--theme-mode-color-white-reverse) !important` : 'var(--theme-mode-color-white) !important',
                                    }}
                                  >
                                    <span
                                      css={{
                                        color: !site.isSoft ? 'var(--theme-mode-color-white-reverse) !important' : 'var(--theme-mode-color-white) !important',
                                        opacity: !site.isSoft ? '0.5' : '1'
                                      }}
                                    >Soft Block</span>
                                  </button>
                                  <div className='trash-btn' style={{ margin: 10 }} onClick={() => handleDelete(site)}>
                                    <img src="images/trash.svg" className="img-default dark:invert-color" />
                                  </div>
                                  <div className="on-off-toggle" >
                                    <input className="on-off-toggle__input" type="checkbox" id={`siteStatus_${site.id}`} onChange={(e) => handleToggle(site, e.target.checked)} checked={site.isActive} />
                                    <label htmlFor={`siteStatus_${site.id}`} className="on-off-toggle__slider focus-label"
                                      css={{
                                        background: !site.isActive ? `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white-reverse),0.8),rgba(var(--theme-mode-rgb-white-reverse),0.8)),linear-gradient(0deg,var(--accent-color),var(--accent-color)),linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.05),rgba(var(--theme-mode-rgb-white),0.05)),var(--theme-mode-color-white) !important` : `var(--accent-color) !important`
                                      }}
                                    ></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
                : <>
                  {/*  */}
                  <div className='no-sites mt-[30px] relative h-[150px] overflow-hidden rounded-[15px]'
                    css={{
                      background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white),0.9), rgba(var(--theme-mode-rgb-white),0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse),0.05), rgba(var(--theme-mode-rgb-white-reverse),0.05)), var(--theme-mode-color-white)` 
                    }}
                  >
                    {
                      theme === 'dark'
                      ?
                      <NoSitesBgDark style={{ width: '100%', position: 'absolute', left: '50%', height: '385px' }} />
                      :
                      <NoSitesBg />
                    }
                    
                    <div id="bg-image" ></div>
                    <span className='no-sites-text absolute left-10 bottom-10 text-center text-2xl font-playfair-display font-bold line-height-normal'
                      css={{
                        background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse),0.6), rgba(var(--theme-mode-rgb-white-reverse),0.6)), var(--accent-color) !important`,
                        WebkitBackgroundClip: 'text !important',
                        WebkitTextFillColor: 'transparent !important'
                      }}
                    >Not blocking any sites</span>
                  </div>
                </>
              }
              <div className="field-block mt-[30px] block ban-data-block">
                <label className="field-label dark:text-white" >Daily Usage Allowance - <span className='accent-text-color'>Hard Block</span></label>
                <div className="block-field-info text-[#909090] dark:text-white" >Set a limit for the amount of time you can spend each day on sites that have ‘Hard block’ turned on.</div>

                <div className="field-data time">
                  <div className="filed-data-block relative w-[48%] min-w-[48%]">
                    <input type="number" id="hours" className="input-field text-black dark:text-white border border-black/10 dark:border-white/15"
                      value={getHoursAndMinutesFromSeconds(blockedSites.dailyUsage).hours.toString()}
                      onChange={(event) => {
                          const value = parseInt(event.target.value);
                          updateDailyUsage(value, false)
                        }
                      }
                      name="hours" placeholder="0" />
                    <span className="input-internal-label absolute right-5 top-[12px]">hours</span>
                  </div>
                  <div className="filed-data-block relative w-[48%] min-w-[48%]">
                    <input type="number" id="minutes" className="input-field text-black dark:text-white border border-black/10 dark:border-white/15" name="minutes" placeholder="0"
                      value={getHoursAndMinutesFromSeconds(blockedSites.dailyUsage).minutes.toString()}
                      onChange={(event) => {
                          const value = parseInt(event.target.value)
                          updateDailyUsage(value, true)
                        }
                      }
                    />
                    <span className="input-internal-label" style={{ position: 'absolute', right: 20, top: 12 }}>mins</span>
                  </div>
                </div>
                {surePopupShow &&
                  <div className='surePopup'
                    css={{
                      background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                      color: `var(--accent-color) !important`
                    }}
                  >
                    <div >
                      <label className="field-label dark:text-white">Are you sure?</label>
                      <p className="text-[#909090] dark:text-white">That seems like quite a bit of time for distractions</p>
                      <span css={{
                        color: `var(--accent-color) !important`
                      }}
                        onClick={() => {
                          setSurePopupShow(false)
                        }}>Yes, I’m sure!</span>
                    </div>
                    <div>
                      <SurePopupIcon></SurePopupIcon>
                    </div>
                  </div>
                }

              </div>

              <div className="field-block mt-[30px] block ban-data-block">
                <label className="field-label dark:text-white">Schedule</label>
                <div className="block-field-info text-[#909090] dark:text-white">Choose the times and days you would like site blocking to be active.</div>

                <p className="dark:text-white mb-2">Choose the times and days you would like site blocking to be active.</p>
                <Interval
                  theme={theme}
                  handleFromTimeChange={handleFromTimeChange}
                  handleTimeChange={handleTimeChange}
                  handleAddInterval={handleAddInterval}
                  handleRemoveInterval={handleRemoveInterval}
                  blockedSites={blockedSites}
                />
              </div>
              <div className="field-block mt-[30px] block ban-data-block">
                <label className="field-label dark:text-white">Selected Days</label>
                <div className="block-field-info text-[#909090] dark:text-white">(Click a day to activate/deactivate)</div>

                <div className="field-data">
                  <div className="filed-data-block w-full"
                    css={{
                      '.general-setting__option--is-selected': {
                        background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important;`,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        color: `var(--theme-mode-color-white)`
                      }
                    }}>

                    <div className="schedule flex">
                      {days.map(renderDay)}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        }

      </li>
    </>
  )

}

export default SiteBlocker